import React from 'react';
import { Card } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import PageWrapper from '../../../PageWrapper/PageWrapper';
import ChangeHeader from './ChangeHeader';
import ServiceFee from '../../ServiceFee/ServiceFee';
import RecommendedPortfolioTable from '../../RecommendedPortfolioTable/RecommendedPortfolioTable';
import TaxImplications from './TaxImplications';
import IPDocCard from '../../../IPDocCard/IPDocCard';

import './ChangeHub.scss';

const ModelChangeHub = ({
    agreementsGroupByType,
    modelAssetAllocationAssociatedFund,
    previousModelAssetAllocationAssociatedFund,
    hasAccounts,
    assetsAsOfDate,
    isInternal,
    monthlyFee,
    dedicatedTotal
}) =>
    <>
        <PageWrapper>
            <ChangeHeader
                header='Implement your new recommended portfolio'
                hasAccounts={hasAccounts}
                isInternal={isInternal}
                modelChange
            />
            {isInternal &&
                <div style={{ marginTop: '32px' }}>
                    <IPDocCard />
                </div>
            }
        </PageWrapper>
        <PageWrapper>
            <div className='changeDisplayContainer'>
                <div className='changeDisplaySection'>
                    <Card id='recc-port-card1' className='modelChangeCard'>
                        <div className='hub-header-container'>
                            <div
                                className='hubProposalHeader'
                                id='recc-model-title'
                            >
                                {`Current ${previousModelAssetAllocationAssociatedFund.modelInformation.name} Portfolio`}
                            </div>
                            <p
                                style={{ fontFamily: 'Nimbus Sans Reg' }}
                                id='recc-model-copy'
                            >
                                {`We previously recommended the ${previousModelAssetAllocationAssociatedFund.modelInformation.name} Portfolio based on 
                                your responses to the investment time horizon and risk tolerance questions in our Service questionnaire and other planning considerations.`}
                            </p>
                        </div>
                        <RecommendedPortfolioTable
                            modelAssetAllocationAssociatedFund={previousModelAssetAllocationAssociatedFund}
                            total={dedicatedTotal}
                        />
                    </Card>
                    {useMediaQuery('(min-width:1166px)') && <TaxImplications agreementsGroupByType={agreementsGroupByType} assetsAsOfDate={assetsAsOfDate} />}
                </div>
                <div className='changeDisplaySection'>
                    <Card id='recc-port-card2' className='modelChangeCard'>
                        <div className='hub-header-container'>
                            <div
                                className='hubProposalHeader'
                                id='recc-model-title'
                            >
                                {`Recommended ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio`}
                            </div>
                            <p
                                style={{ fontFamily: 'Nimbus Sans Reg' }}
                                id='recc-model-copy'
                            >
                                {`We now recommend the ${modelAssetAllocationAssociatedFund.modelInformation.name} Portfolio based on 
                                your updated responses to the investment time horizon and risk tolerance questions in our Service
                                questionnaire and other planning considerations.`}
                            </p>
                        </div>
                        <RecommendedPortfolioTable
                            modelAssetAllocationAssociatedFund={modelAssetAllocationAssociatedFund}
                            total={dedicatedTotal}
                        />
                    </Card>
                    <div style={{ paddingTop: '32px' }} id='service-fee-rj'>
                        <ServiceFee
                            total={dedicatedTotal}
                            fee={monthlyFee}
                        />
                    </div>
                    {!useMediaQuery('(min-width:1166px)') && <TaxImplications agreementsGroupByType={agreementsGroupByType} assetsAsOfDate={assetsAsOfDate} />}
                </div>
            </div>
        </PageWrapper>
    </>;

export default ModelChangeHub;
